import { COLORS, marginSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-self: center;
  padding: 30rem;
  width: 100%;
`;

export const FormWrapper = styled.div`
  width: 100%;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10rem;
`;

export const Title = styled.div`
  font-size: 24px;
  font-weight: 300;
  line-height: 36px;
  letter-spacing: 0em;
  text-align: left;
  color: ${COLORS.BLACK};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10rem;
`;

export const Label = styled.div`
  margin-bottom: 10rem;
  color: ${COLORS.BLACK};
`;

export const HorizontalLine = styled.div`
  max-width: 635rem;
  width: 100%;
  height: 1rem;
  background-color: ${COLORS.GRAY_300};
`;

export const ApplyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30rem;

  ${respondTo.smallPhone`
    flex-direction: column;
    gap: 10rem;
  `}
`;
export const ColumnContainer = styled.div`
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 10rem;
`;
export const RowSpaceBetween = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10rem;
`;

export const ColumnContainerSelect = styled.div`
  display: flex;
  flex-direction: column;
  width: 300rem;
  margin-bottom: ${marginSm};
`;

export const PasswordRow = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PasswordLabel = styled.div`
  color: ${COLORS.BLACK};
  cursor: pointer;
`;

export const IconWrapper = styled.div`
  padding-bottom: 16rem;
`;
